import { Stack, Typography, useTheme } from "@mui/material";
import "dayjs/locale/cs";
import { Check } from "lucide-react";
import type { Dispatch, FC, SetStateAction } from "react";

type Props = {
	text: string;
	selected: boolean;
	onClick: Dispatch<SetStateAction<string[]>>;
};

export const ActivitiesFilterSimpleItem: FC<Props> = ({
	text,
	selected,
	onClick,
}) => {
	const theme = useTheme();

	const handleClick = () => {
		onClick((prev) =>
			prev.includes(text) ? prev.filter((t) => t !== text) : [...prev, text],
		);
	};

	return (
		<Stack
			direction="row"
			justifyContent="space-between"
			alignItems="center"
			height={48}
			paddingInline="8px"
			onClick={handleClick}
		>
			<Typography variant="deprecatedBody1" sx={{ cursor: "pointer" }}>
				{text}
			</Typography>
			{selected && <Check color={theme.palette.primary.main} />}
		</Stack>
	);
};
